import React from "react";
import "./SectionTitle.css";

const SectionTitle = ({ title }: { title: string }) => <div className="section-title">{title}</div>;

export default SectionTitle;
